export default __webpack_public_path__ + "static/media/11.9fe65a33.PNG";